export default "__VITE_ASSET__Dqqp33Aq__"